/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_LeadInputs */

const en_mk_cmp_multica_lead = /** @type {(inputs: Mk_Cmp_Multica_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both treat agents as colleagues rather than tools. The difference is who they serve: Multica is built for engineering teams already running coding agents on their own machines, KerjaBareng for a whole office with nobody to install anything.`)
};

const id_mk_cmp_multica_lead = /** @type {(inputs: Mk_Cmp_Multica_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keduanya memperlakukan agen sebagai rekan kerja, bukan alat. Bedanya ada pada siapa yang dilayani: Multica dibangun untuk tim engineering yang sudah memakai coding agent di komputernya sendiri, KerjaBareng untuk seluruh isi kantor yang tidak punya siapa pun untuk memasang apa pun.`)
};

/**
* | output |
* | --- |
* | "Both treat agents as colleagues rather than tools. The difference is who they serve: Multica is built for engineering teams already running coding agents on ..." |
*
* @param {Mk_Cmp_Multica_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_lead = /** @type {((inputs?: Mk_Cmp_Multica_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_lead(inputs)
	return en_mk_cmp_multica_lead(inputs)
});